import React from "react";

export const NotFound = () => {
  return (
    <div>
      <h1>Not Found</h1>
      <p className="lead">Page you are looking for does not exists</p>
    </div>
  );
};

export default NotFound;
